import { PropsWithChildren, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../hooks/useUserContext';
import { useActivityTracker } from '../hooks/useActivityTracker';
import { InactivityWarning } from '../components/support/InactivityWarning';
import { paths } from '../utils/paths';
import './App.css';

type ProtectedComponentProps = PropsWithChildren;

export default function ProtectedComponent({ children }: ProtectedComponentProps) {
  
    const user = useUserContext();
    const navigate = useNavigate();

    // Initialize activity tracker for authenticated users
    const activityTracker = useActivityTracker();

    useEffect(() => {
        if(user === null){
            console.log('Unauthorized call, redirecting to Login.')
            navigate(paths.auth.signIn, {replace: true});
        }
    }, [navigate, user])

    // Additional heartbeat trigger when user becomes active
    useEffect(() => {
        if (!user) return;

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                // User returned to the tab, send heartbeat to refresh token
                activityTracker.sendHeartbeat();
            }
        };

        const handleFocus = () => {
            // User focused the window, send heartbeat
            activityTracker.sendHeartbeat();
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', handleFocus);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('focus', handleFocus);
        };
    }, [user, activityTracker]);

    return (
      <div>
        {children}
        <InactivityWarning />
      </div>
    );
}

